<app-frame title="Настройки оповещений">
  <ng-container actions>
    <button nz-button (click)="save()" nzType="primary" [disabled]="processing">Сохранить</button>
  </ng-container>
  <ng-container>
    <form class="fieldList" [formGroup]="form">
      <div class="field">
        <div class="caption">Количество попыток дозвона</div>
        <div class="field__input">
          <input type="number" [disabled]="processing" formControlName="SetMaxAttempts" nz-input placeholder="5">
        </div>
      </div>
      <div class="field">
        <div class="caption">Время дозвона (сек)</div>
        <div class="field__input">
          <input type="number" [disabled]="processing" formControlName="SetAnswerWaitTime" nz-input placeholder="5">
        </div>
      </div>
      <div class="field">
        <div class="caption">Пауза между попытками дозвона (сек)</div>
        <div class="field__input">
          <input type="number" [disabled]="processing" formControlName="SetAttemptsDelay" nz-input placeholder="5">
        </div>
      </div>
    </form>

  </ng-container>
</app-frame>
